import { Filter, FilterRequestForCombo } from "../../backend/clients";

export class ComboData {
    list: any[] = [];
    totalRecords: number = 0;
    rowsPerPageOption: number = 10;
    additionalFilters: Filter[] = [];

    dataGetter: ((filter: FilterRequestForCombo) => Promise<any>) | undefined;

    async getData(textFilter: string | null, pageNumber: number) : Promise<void> {
        let filter: FilterRequestForCombo = {
            pageNumber: pageNumber || 1,
            pageSize: this.rowsPerPageOption,
            textFilter: textFilter,
            additionalFilters: this.additionalFilters
        };

        let result = this.dataGetter ? await this.dataGetter(filter) : null;

        this.list = result?.results || [];
        this.totalRecords = result?.totalCount ?? 0;

    }

    constructor(dataGetter?: (filter: FilterRequestForCombo) => Promise<any>) {
        this.dataGetter = dataGetter;
    }

    reset() : void {
        this.list = [];
        this.totalRecords = 0;
    }
}